import React, { useEffect, useState } from 'react';

import Routes from '../routes/Routes';
import Header from './Header';
import Footer from './Footer';
import { useSelector } from 'react-redux';

import Cart from '../components/Cart';
import jwtDecode from 'jwt-decode';

const Layout = () => {
  const cartUi = useSelector(state => state.cartUi.cartIsVisible);
  useEffect(() => {
    getUser();
  }, []);
  const getUser = async () => {
    const token = localStorage.getItem('token');
    console.log(token);
    if (token != null) {
      const decode = jwtDecode(token);
      console.log(decode);
      setUserId(decode.UserId);
      const isDataArray = Array.isArray(decode.roles);
      setIsHost(isDataArray);
    }
  };
  const [userId, setUserId] = useState('');
  const [isHost, setIsHost] = useState(false);
  return (
    <div>
      <Header userId={userId} isHost={isHost} />
      <div>
        <Routes />
      </div>
      {cartUi && <Cart />}
      <Footer />
    </div>
  );
};

export default Layout;
